export const viewRouteId = 'datahubitem-view';
export const rssRouteId = 'datahub_rss.xml';
export const redirectRouteId = 'dataset-redirect';
